var roundToNearestStep = function roundToNearestStep(value, offset, step, precision) {
  return Number((Math.round((value - offset) / step) * step + offset).toFixed(precision));
};
var clamp = function clamp(value, min, max) {
  return Math.min(Math.max(min, value), max);
};
var valueToPercentage = function valueToPercentage(value, min, max) {
  return (value - min) * 100 / (max - min);
};
var percentageToValue = function percentageToValue(percent, min, max) {
  return (max - min) * percent + min;
};

export { clamp, percentageToValue, roundToNearestStep, valueToPercentage };
